module.exports = __webpack_public_path__ + "img/various-items-active-mobile.0ff8f13e.svg";